<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-dedication element-with-heading" epub:type="dedication" id="dedication" role="doc-dedication">
<div class="heading heading-with-title heading-without-image" id="dedication-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Dedication</h1>
</div>
</div>
</div>
</div>
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">This one is for John ‘Widgett’ Robinson, Maegan Leith Robinson,</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Jenna Leith, C.J. Leith, and Emily Leith</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">You’re all absolutely crazy…and I love you for that!</p>
</div>
</div>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">And, as always, to Sara Jo!</p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?51bf3e0a